import { alpha, Box, styled, Typography } from '@sb/cc-design-system';

export const OverrideRightSideBarWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

export const OverrideRightSideBarHeader = styled(Typography)(
  ({ theme }) => `
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: ${alpha(theme.palette.secondary.contrastText, 0.6)};
`,
);

export const OverrideRightSideBarContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: 12px;
  width: 100%;
  min-height: 0;
  overflow: hidden;
`;

export const SchedulerMessageWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 28px;
`;

export const StyledEmptyProviderMessage = styled(Typography)(
  ({ theme }) => `
  width: 245px;
  padding-left: 40px;
  text-align: center;
  color: ${alpha(theme.palette.secondary.contrastText, 0.38)};
`,
);

export const StyledNotEditableProviderMessage = styled(
  StyledEmptyProviderMessage,
)(
  () => `
  padding-left: 12px;
`,
);

export const NotEditableState = styled(Box)`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  min-height: 0;
`;

export const NotEditableImage = styled('img')`
  width: 233px;
  height: 211px;
  object-fit: contain;
`;
export const MatchedComponentsList = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  height: 0;
  gap: 12px;
  width: 100%;
  min-height: 0;
  overflow-y: auto;
  padding-right: 16px;
`;

export const SearchFieldWrapper = styled(Box)`
  width: 100%;
`;

export const MiniCardImageSlotPlaceholder = styled(Box)(
  ({ theme }) => `
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: ${theme.colorPalette.neutral.surface.surface3};
`,
);

export const MiniCardImageSlotPlaceholderText = styled(Typography)(
  ({ theme }) => `
  padding: 0 10px;
  color: ${alpha(theme.palette.secondary.contrastText, 0.6)};
`,
);

export const InitialLoadingWrapper = styled(Box)`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
`;

export const MiniCardWrapper = styled(Box)`
  width: 100%;

  > div {
    width: 100%;
  }
`;

export const LoadingMoreWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 8px 0 4px;
`;

export const InViewTrigger = styled(Box)`
  width: 100%;
  min-height: 24px;
  flex-shrink: 0;
`;

export const ExpandedComponentModalContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ExpandedComponentPreviewWrapper = styled(Box)(
  ({ theme }) => `
  width: 100%;
  height: 320px;
  border: 1px solid ${theme.palette.divider};
  border-radius: 8px;
  background: ${theme.palette.grey[200]};
  overflow: hidden;
`,
);

export const ExpandedComponentTags = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ExpandedComponentPreviewInner = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
